var map = {
	"./Ashworth et al. 2019.pdf": "50f7",
	"./about-01.jpg": "0865",
	"./about-02.jpg": "0ac7",
	"./about-logo.png": "bae2",
	"./ai-input-api.svg": "d09f",
	"./ai-input-csv.svg": "b782",
	"./ai-input-html.svg": "a9c4",
	"./ai-input-library.svg": "1a80",
	"./ai-input-manual.svg": "2796",
	"./ai-input-pdf.svg": "fbee",
	"./ai-input-sql.svg": "1595",
	"./ai-input-text.svg": "dd2f",
	"./ai-input-word.svg": "8316",
	"./ai-task-answering.svg": "10c1",
	"./ai-task-classification.svg": "ae21",
	"./ai-task-extraction.svg": "20c3",
	"./ai-task-generation.svg": "7320",
	"./ai-task-hire.svg": "1903",
	"./ai-task-sentiment.svg": "d637",
	"./ai-task-summarization.svg": "9bc5",
	"./ai-task-tabular-classification.svg": "21d5",
	"./ai-task-tagging.svg": "80fa",
	"./annotating-output.svg": "3b60",
	"./api.png": "879a",
	"./aws.svg": "d9a2",
	"./csv-logo.png": "fe87",
	"./custom-models.svg": "35b9",
	"./docker.svg": "2cc5",
	"./docs-image-01.png": "b050",
	"./docs-image-02.png": "69f5",
	"./excel-logo.png": "1498",
	"./favicon.png": "621a",
	"./features-avatar.jpg": "4431",
	"./features-home-bg-01.png": "5f88",
	"./features-home-element-01.png": "48dc",
	"./features-home-element-02.png": "b0c1",
	"./features-home-element-03.png": "2178",
	"./features-top-image.png": "6953",
	"./gifs/labeling.gif": "5e5f",
	"./google-Sheets-logo.svg": "a0f6",
	"./hero-image-01.png": "1242",
	"./hero.png": "40c0",
	"./huggingface.svg": "3ac8",
	"./labeling-example.svg": "bd08",
	"./metatext-dashboard.svg": "7f9d",
	"./news-01.jpg": "dc57",
	"./news-02.jpg": "b378",
	"./news-03.jpg": "f123",
	"./news-author-01.jpg": "91ab",
	"./news-author-02.jpg": "3cba",
	"./news-author-03.jpg": "8c88",
	"./news-author-04.jpg": "7444",
	"./news-author-05.jpg": "2eb5",
	"./news-author-06.jpg": "e01e",
	"./news-single.jpg": "cc05",
	"./onboarding-steps.svg": "ae19",
	"./pipedream.png": "29c7",
	"./planet-avatar-01.png": "da3c",
	"./planet-avatar-02.png": "c1c1",
	"./planet-avatar-03.png": "1518",
	"./planet-avatar-04.png": "e927",
	"./planet-avatar-05.png": "6248",
	"./planet.png": "d0ec",
	"./pre-build-models.svg": "f97b",
	"./preview.svg": "8251",
	"./project-setup-steps.svg": "8a813",
	"./rest-logo.png": "e8ff",
	"./salesforce-logo.jpg": "8235",
	"./slack-logo.png": "0d49",
	"./slack.png": "3543",
	"./spreadsheet-logo.png": "d9b0",
	"./stripe.png": "f9f4",
	"./team-member-01.jpg": "0928",
	"./team-member-02.jpg": "75d7",
	"./team-member-03.jpg": "6445",
	"./team-member-04.jpg": "8bd9",
	"./team-member-05.jpg": "bde0",
	"./team-member-06.jpg": "3a96",
	"./team-member-07.jpg": "9f78",
	"./team-member-08.jpg": "a7d4",
	"./team-member-09.jpg": "3835",
	"./team-mosaic-01.jpg": "de08",
	"./team-mosaic-02.jpg": "41da",
	"./team-mosaic-03.jpg": "14f4",
	"./team-mosaic-04.jpg": "210a",
	"./testimonial-01.jpg": "e2b8",
	"./testimonial-02.jpg": "6078",
	"./testimonial-03.jpg": "5d8e",
	"./training-example.svg": "c3b5",
	"./tutorial-01.jpg": "a3e2",
	"./tutorial-02.jpg": "2d2d",
	"./tutorial-03.jpg": "fbf1",
	"./tutorial-04.jpg": "cfe2",
	"./tutorial-05.jpg": "4a27",
	"./tutorial-06.jpg": "1cbc",
	"./tutorial-07.jpg": "f696",
	"./tutorial-08.jpg": "e037",
	"./tutorial-09.jpg": "63ff",
	"./twilio.png": "b9a9",
	"./undraw_Add_files_re_v09g.svg": "cef7",
	"./undraw_Artificial_intelligence_re_enpp.svg": "9cac",
	"./undraw_Online_information_re_erks.svg": "17af",
	"./undraw_apps_m7mh.svg": "fe3a",
	"./undraw_data_processing_yrrv.svg": "bdfd",
	"./undraw_processing_qj6a.svg": "2c3a",
	"./undraw_sentiment_analysis_jp6w.svg": "059b",
	"./upload-example.png": "66fe",
	"./zapier-logo.png": "9d9c",
	"./zapier.png": "d1b0",
	"./zendesk-logo.png": "fe8d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b6a";